import { ComunicadoVisualizacaoModal, type ComunicadoVisualizacaoData } from '../comunicados/ComunicadoVisualizacaoModal';

export type NotificacaoDetalhe = {
  id: string;
  titulo?: string | null;
  mensagem?: string | null;
  tipoNotificacao?: string | null;
  dataHora?: string | null;
  criadoEm?: string | null;
  lidaEm?: string | null;
  midiaUrl?: string | null;
  imagemUrl?: string | null;
  anexoUrl?: string | null;
  aluno?: { id?: string; nome?: string; matricula?: string; fotoUrl?: string | null } | null;
  configPreview?: any;
  escola?: { id?: string; nome?: string; logoUrl?: string } | null;
  municipio?: { id?: string; nome?: string; logoUrl?: string } | null;
};

type Props = {
  notificacao: NotificacaoDetalhe | null;
  onClose: () => void;
};

/**
 * Modal oficial de visualização de notificações e comunicados timbrados.
 * Utiliza o componente oficial ComunicadoVisualizacaoModal em conformidade com o design system do projeto.
 */
export function NotificacaoDetalheSheet({ notificacao: n, onClose }: Props) {
  if (!n) return null;

  const dataConvertida: ComunicadoVisualizacaoData = {
    id: n.id,
    titulo: n.titulo || 'Comunicado Oficial',
    corpo: n.mensagem || '',
    mensagem: n.mensagem || '',
    tipo: n.tipoNotificacao || 'AVISO',
    categoria: n.tipoNotificacao || 'INSTITUCIONAL',
    criadoEm: n.dataHora || n.criadoEm || new Date().toISOString(),
    lido: !!n.lidaEm,
    configPreview: n.configPreview || {
      midiaUrl: n.midiaUrl || n.imagemUrl || n.anexoUrl || null,
      tenantName: n.escola?.nome || n.municipio?.nome || 'Comunicação Oficial Escolar',
    },
    aluno: n.aluno,
    escola: n.escola,
    municipio: n.municipio,
  };

  return (
    <ComunicadoVisualizacaoModal
      open={!!n}
      onClose={onClose}
      comunicadoInicial={dataConvertida}
      listaComunicados={[dataConvertida]}
    />
  );
}
